export default {
  title: 'Saisir le montant du remboursement',
  description: 'Disponible pour remboursement : {{amount}}',
  form: {
    amount: {
      label: 'Rembourser',
    },
    reason: {
      label: 'Motif',
      options: {
        requested_by_customer: 'demandé par le client',
        reclamation: 'réclamation',
        communication_error: 'erreur de communication',
        other: 'autre',
      },
    },
    manual_reason: {
      label: 'Saisir le motif du remboursement',
    },
  },
  feedback: {
    amount_too_small: 'Montant minimum de remboursement {{amount}}',
    amount_too_big: 'Montant maximum de remboursement {{amount}}',
    payment_frozen:
      'Remboursement déjà demandé par le client. {{provider}} est en contact avec le client concernant le remboursement',
  },
  buttons: {
    refund: 'Rembourser',
    cancel: 'Annuler',
  },
  toasts: {
    refund_successful: 'Remboursement de {{amount}} initié avec succès !',
  },
};
